import { render } from "./SecurityGlobalFooter.vue?vue&type=template&id=4cad025e&scoped=true"
import script from "./SecurityGlobalFooter.vue?vue&type=script&lang=js"
export * from "./SecurityGlobalFooter.vue?vue&type=script&lang=js"

import "./SecurityGlobalFooter.vue?vue&type=style&index=0&id=4cad025e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cad025e"]])

export default __exports__